const LANG = {
  en: {
    company: 'Al Salam Investments', app: 'Clients Manager', chooseRole: 'Select your role',
    admin: 'Admin', adminD: 'Full access', manager: 'Sales Manager', managerD: 'Monitor team', agent: 'Sales Agent', agentD: 'Your clients',
    selectAgent: 'Select your name:', selectManager: 'Select manager:', back: 'Back',
    dashboard: 'Dashboard', portfolio: 'Portfolio', newAccounts: 'New Accounts', newLogins: 'New Logins', newClients: 'New Clients', ftd: 'FTD', leads: 'Leads', notActive: 'Not Active', users: 'Users',
    logout: 'Sign Out', lang: 'AR', login: 'Login',
    email: 'Email', password: 'Password', signIn: 'Sign In', signingIn: 'Signing in...', loginError: 'Invalid email or password',
    search: 'Search...', allAgents: 'All Agents', allStatuses: 'All Statuses', allTypes: 'All Types',
    totalLeads: 'Leads', interested: 'Interested', noAnswer: 'No Answer', pending: 'Pending',
    totalAccounts: 'Accounts', totalFTD: 'FTD Count', ftdTotal: 'FTD Total', todayAcc: 'Today',
    totalClients: 'Total Clients', activeClients: 'Active', totalDeposits: 'Total Deposits', totalLogins: 'Total Logins',
    totalEquity: 'Total Equity', totalVolume: 'Total Volume', totalProfit: 'Net Profit',
    clientName: 'Client Name', phone: 'Phone', accountManager: 'Agent', date: 'Date',
    status: 'Status', action: 'Action', comments: 'Comments', cuAccount: 'CU Account', openDate: 'Open Date',
    ftdDate: 'FTD Date', amount: 'Amount', clientStatus: 'Type', uploadedBy: 'Source',
    cancel: 'Cancel', addLead: 'Add Lead', addNewLead: 'New Lead', bulkUpload: 'Bulk Upload',
    selectAgent2: 'Select Agent', selectStatus: 'Status', selectAction: 'Action',
    writeComment: 'Write comment...', saved: 'Saved', leadAdded: 'Lead added', noData: 'No data',
    exportData: 'Export', uploadAccounts: 'Upload Accounts', uploadFTD: 'Upload FTD', uploadPortfolio: 'Upload Portfolio', uploadNotActive: 'Upload Not Active',
    addUser: 'Add User', name: 'Name', role: 'Role', assignedAgents: 'Assigned Agents',
    chartAccounts: 'New Accounts by Agent', chartFTD: 'FTD Amount by Agent', chartLeads: 'Leads by Agent', clientStatusChart: 'Client Status',
    clear: 'Clear', downloadTpl: 'Template',
    loginNo: 'Login', tDeposit: 'T.Deposit', tWithdraw: 'T.Withdraw', tVolume: 'T.Volume', tProfit: 'T.Profit',
    deposit: 'Deposit', withdraw: 'Withdraw', equity: 'Equity', floatingPL: 'Floating P/L', volume: 'Volume',
    accType: 'Acc Type', clientType: 'Client Type', country: 'Country', month: 'Month',
    depositVsWithdraw: 'Deposits vs Withdrawals', accountTypes: 'Account Types',
    uploading: 'Uploading...', uploadSuccess: 'Upload successful', uploadError: 'Upload failed',
    loading: 'Loading...', deleteUser: 'Delete', editUser: 'Edit', save: 'Save',
    newPassword: 'New Password', confirmDelete: 'Are you sure?', yes: 'Yes', no: 'No',
    managerAgents: 'Manager Agents', selectAgents: 'Select agents for this manager',
    dataLastUpdate: 'Last updated', rows: 'rows',
    followUp: 'Follow Up', addFollowUp: 'Add Follow Up', editFollowUp: 'Edit Follow Up',
    followUpStatus: 'Status', followUpAction: 'Action', followUpComment: 'Comment',
    lastUpdated: 'Last Updated', updatedBy: 'Updated By',
  },
  ar: {
    company: 'استثمارات السلام', app: 'إدارة العملاء', chooseRole: 'اختر دورك',
    admin: 'المدير العام', adminD: 'صلاحيات كاملة', manager: 'مدير المبيعات', managerD: 'مراقبة الفريق', agent: 'موظف مبيعات', agentD: 'عملاءك',
    selectAgent: 'اختر اسمك:', selectManager: 'اختر المدير:', back: 'رجوع',
    dashboard: 'لوحة التحكم', portfolio: 'المحفظة', newAccounts: 'حسابات جديدة', newLogins: 'تسجيلات جديدة', newClients: 'عملاء جدد', ftd: 'أول إيداع', leads: 'العملاء المحتملين', notActive: 'غير نشط', users: 'المستخدمين',
    logout: 'خروج', lang: 'EN', login: 'تسجيل الدخول',
    email: 'البريد الإلكتروني', password: 'كلمة المرور', signIn: 'دخول', signingIn: 'جاري الدخول...', loginError: 'بريد أو كلمة مرور خاطئة',
    search: 'بحث...', allAgents: 'كل الموظفين', allStatuses: 'كل الحالات', allTypes: 'كل الأنواع',
    totalLeads: 'العملاء', interested: 'مهتم', noAnswer: 'لا رد', pending: 'بانتظار',
    totalAccounts: 'الحسابات', totalFTD: 'عدد الإيداعات', ftdTotal: 'إجمالي', todayAcc: 'اليوم',
    totalClients: 'إجمالي العملاء', activeClients: 'نشط', totalDeposits: 'إجمالي الإيداعات', totalLogins: 'إجمالي الحسابات',
    totalEquity: 'إجمالي الملكية', totalVolume: 'إجمالي الحجم', totalProfit: 'صافي الربح',
    clientName: 'العميل', phone: 'الهاتف', accountManager: 'الموظف', date: 'التاريخ',
    status: 'الحالة', action: 'الإجراء', comments: 'الملاحظات', cuAccount: 'رقم الحساب', openDate: 'تاريخ الفتح',
    ftdDate: 'تاريخ الإيداع', amount: 'المبلغ', clientStatus: 'النوع', uploadedBy: 'المصدر',
    cancel: 'إلغاء', addLead: 'إضافة', addNewLead: 'عميل جديد', bulkUpload: 'رفع مجموعة',
    selectAgent2: 'اختر موظف', selectStatus: 'الحالة', selectAction: 'الإجراء',
    writeComment: 'اكتب ملاحظاتك...', saved: 'تم الحفظ', leadAdded: 'تمت الإضافة', noData: 'لا توجد بيانات',
    exportData: 'تصدير', uploadAccounts: 'رفع الحسابات', uploadFTD: 'رفع الإيداعات', uploadPortfolio: 'رفع المحفظة', uploadNotActive: 'رفع غير النشط',
    addUser: 'إضافة مستخدم', name: 'الاسم', role: 'الدور', assignedAgents: 'الموظفين المعينين',
    chartAccounts: 'الحسابات الجديدة', chartFTD: 'الإيداعات بالموظف', chartLeads: 'العملاء بالموظف', clientStatusChart: 'حالة العملاء',
    clear: 'مسح', downloadTpl: 'القالب',
    loginNo: 'رقم الدخول', tDeposit: 'إجمالي الإيداع', tWithdraw: 'إجمالي السحب', tVolume: 'إجمالي الحجم', tProfit: 'إجمالي الربح',
    deposit: 'إيداع', withdraw: 'سحب', equity: 'الملكية', floatingPL: 'ربح عائم', volume: 'الحجم',
    accType: 'نوع الحساب', clientType: 'نوع العميل', country: 'الدولة', month: 'الشهر',
    depositVsWithdraw: 'الإيداعات مقابل السحوبات', accountTypes: 'أنواع الحسابات',
    uploading: 'جاري الرفع...', uploadSuccess: 'تم الرفع بنجاح', uploadError: 'فشل الرفع',
    loading: 'جاري التحميل...', deleteUser: 'حذف', editUser: 'تعديل', save: 'حفظ',
    newPassword: 'كلمة مرور جديدة', confirmDelete: 'هل أنت متأكد؟', yes: 'نعم', no: 'لا',
    managerAgents: 'موظفي المدير', selectAgents: 'اختر الموظفين لهذا المدير',
    dataLastUpdate: 'آخر تحديث', rows: 'سجل',
    followUp: 'المتابعة', addFollowUp: 'إضافة متابعة', editFollowUp: 'تعديل المتابعة',
    followUpStatus: 'الحالة', followUpAction: 'الإجراء', followUpComment: 'التعليق',
    lastUpdated: 'آخر تحديث', updatedBy: 'تم التحديث بواسطة',
  }
};

export const STATUSES = ['Interested', 'Not Interested', 'Need Time', 'Converted', 'Active Account', 'Retention', 'No Answer', 'Disconnected', 'Wrong Number'];
export const ACTIONS = ['Call Again', 'Email Sent', 'Follow-Up', 'Left Voice Message', 'Need Training', 'Schedule Meeting', 'Sent Documents', 'WhatsApp Sent'];

export const FU_STATUSES = ['Interested', 'Not Interested', 'Need Time', 'Active Account', 'Reactive', 'No Answer', 'Disconnected', 'Wrong Number'];
export const FU_ACTIONS = ['Call Again', 'Email Sent', 'Follow-Up', 'Left Voice Message', 'Need Training', 'Schedule Meeting', 'Sent Documents', 'WhatsApp Sent', 'Closed Account', 'Convert Account Type'];

export const FU_STATUS_COLORS = {
  Interested: { bg: '#d4edda', tx: '#155724' },
  'Not Interested': { bg: '#f8d7da', tx: '#721c24' },
  'Need Time': { bg: '#fff3cd', tx: '#856404' },
  'Active Account': { bg: '#c3e6cb', tx: '#0d5524' },
  Reactive: { bg: '#d4edda', tx: '#155724' },
  'No Answer': { bg: '#ffeeba', tx: '#856404' },
  Disconnected: { bg: '#e2e3e5', tx: '#383d41' },
  'Wrong Number': { bg: '#d6d8db', tx: '#1b1e21' },
  // Old values (still display with color, just not in dropdown)
  Rejected: { bg: '#f5c6cb', tx: '#721c24' },
};

export const FU_ACTION_COLORS = {
  'Call Again': { bg: '#cce5ff', tx: '#004085' },
  'Email Sent': { bg: '#d1ecf1', tx: '#0c5460' },
  'Follow-Up': { bg: '#fff3cd', tx: '#856404' },
  'Left Voice Message': { bg: '#e2e3e5', tx: '#383d41' },
  'Need Training': { bg: '#fce4b8', tx: '#7c4a03' },
  'Schedule Meeting': { bg: '#cce5ff', tx: '#004085' },
  'Sent Documents': { bg: '#fde8d0', tx: '#8a4500' },
  'WhatsApp Sent': { bg: '#d4edda', tx: '#155724' },
  'Closed Account': { bg: '#f8d7da', tx: '#721c24' },
  'Convert Account Type': { bg: '#d6d8f8', tx: '#3b3d99' },
  // Old values (still display with color, just not in dropdown)
  Done: { bg: '#d4edda', tx: '#155724' },
  'Follow-up Tomorrow': { bg: '#fff3cd', tx: '#856404' },
  Closed: { bg: '#f8d7da', tx: '#721c24' },
  'Send Documents': { bg: '#fde8d0', tx: '#8a4500' },
};

export const STATUS_COLORS = {
  Interested: { bg: '#d4edda', tx: '#155724' },
  'Not Interested': { bg: '#f8d7da', tx: '#721c24' },
  'Need Time': { bg: '#fff3cd', tx: '#856404' },
  Converted: { bg: '#c3e6cb', tx: '#0d5524' },
  'Active Account': { bg: '#b8daff', tx: '#004085' },
  Retention: { bg: '#d6d8f8', tx: '#3b3d99' },
  'No Answer': { bg: '#ffeeba', tx: '#856404' },
  Disconnected: { bg: '#e2e3e5', tx: '#383d41' },
  'Wrong Number': { bg: '#d6d8db', tx: '#1b1e21' },
  // Old values (still display with color, just not in dropdown)
  Rejected: { bg: '#f5c6cb', tx: '#721c24' },
  Reactive: { bg: '#d4edda', tx: '#155724' },
};

export const ACTION_COLORS = {
  'Call Again': { bg: '#cce5ff', tx: '#004085' },
  'Email Sent': { bg: '#d1ecf1', tx: '#0c5460' },
  'Follow-Up': { bg: '#fff3cd', tx: '#856404' },
  'Left Voice Message': { bg: '#e2e3e5', tx: '#383d41' },
  'Need Training': { bg: '#fce4b8', tx: '#7c4a03' },
  'Schedule Meeting': { bg: '#cce5ff', tx: '#004085' },
  'Sent Documents': { bg: '#fde8d0', tx: '#8a4500' },
  'WhatsApp Sent': { bg: '#d4edda', tx: '#155724' },
  // Old values (still display with color, just not in dropdown)
  Converted: { bg: '#d4edda', tx: '#155724' },
  Done: { bg: '#d4edda', tx: '#155724' },
  'Follow-up Tomorrow': { bg: '#fff3cd', tx: '#856404' },
  'Send Documents': { bg: '#fde8d0', tx: '#8a4500' },
  Closed: { bg: '#f8d7da', tx: '#721c24' },
  'Convert Account Type': { bg: '#d6d8f8', tx: '#3b3d99' },
};

export const CLIENT_STATUS_COLORS = {
  Active: { bg: '#d4edda', tx: '#155724' },
  'Not Active': { bg: '#f8d7da', tx: '#721c24' },
  Dormant: { bg: '#fff3cd', tx: '#856404' },
};

export default LANG;
